import style from "./ShippingInfoRow.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import InputNumber from "components/inputs/InputNumber";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import {
  clone,
  getCurrentLanguageCode,
  validateInputs,
} from "shared/utils/Utils";
import { requester, storeRequester } from "App";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useDispatch } from "react-redux";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import { useNavigate } from "react-router-dom";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import P from "components/P";
import Center from "layouts/wrapper/Center";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import { WishReducer } from "shared/redux/reducers/shopping/WishReducer";
import CustomButton from "components/buttons/CustomButton";

const ShippingInfoRow = forwardRef((props, ref) => {
  const { isMobile } = useContext(BrowserDetectContext);
  const { shippingInfo, index } = props;
  const { t } = useTranslation();
  const [isChecked, setChecked] = useState(false);
  const [checkedData, setCheckedData] = useState();
  const [wish, setWish] = useState();
  const input = useRef();
  const [helperText, setHelperText] = useState("");
  const inputs = useRef([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsAdd } = props;
  const isDefaultAddress = shippingInfo?.metadata?.default === true; //기본배송지 처리



  const onDeleteClick = () => {
    const onDeleteClick = async () => {
      await storeRequester.deleteShippingAddress(shippingInfo.id);
      setIsAdd((prev) => !prev);
    };

    const onCancelClick = () => { };

    NiceModal.show("confirm", {
      message: t("confirmCartProductDelete"),
      confirmText: t("delete"),
      cancelText: t("cancel"),
      onConfirm: onDeleteClick,
      onCancel: onCancelClick,
    });
  };

  const callback = (index, state) => {

    if (props.callback) {
      props.callback(index, state, shippingInfo);
    }
  };



  useEffect(() => {
    if (props.data) {
      setCheckedData(props.data);
    }
  }, [props.data]);

  useImperativeHandle(ref, () => ({
    isChecked() {
      return isChecked;
    },
    setChecked(value) {
      input.current.setChecked(value);
    },
    isCheckedVaild() {
      return input.current.isChecked();
    },
  }));

  const onModifyClick = (id) => {

    NiceModal.show("shippingInfoEditModal", {
      data: shippingInfo,
      callback: onEditModalClose,
      setIsAdd: setIsAdd,
    });
  };

  const onEditModalClose = (value) => {

    if (props.shippingInfoEditCallback) {
      props.shippingInfoEditCallback(value);
    }
  };

  return (
    <VerticalFlex>
      <FlexChild key={index} padding={"15px 10px"}>
        <HorizontalFlex>
          {!isMobile && (
            <FlexChild width={"15%"} justifyContent={"center"}>
              <P>{shippingInfo && shippingInfo.name}</P>
              {isDefaultAddress && (
                <div style={{
                  display: "inline-flex",
                  padding: "4px 8px",
                  marginLeft: "5px",
                  backgroundColor: "var(--main-color)",
                  color: "white",
                  borderRadius: "4px",
                  fontSize: "14px",
                  width: "fit-content"
                }}>
                  기본배송지
                </div>
              )}
            </FlexChild>
          )}
          <FlexChild justifyContent={"center"}>
            <VerticalFlex>
              <FlexChild alignItems={"center"}>
                <P>
                  { shippingInfo && "[" + shippingInfo?.postal_code + "]"}{" "}
                  {shippingInfo && shippingInfo.address_1} {shippingInfo && shippingInfo.address_2}
                </P>
              </FlexChild>
              <FlexChild alignItems={"center"}>
                <P>{shippingInfo && shippingInfo.addressDetail}</P>
              </FlexChild>
            </VerticalFlex>
          </FlexChild>
          {!isMobile && (
            <FlexChild width={"150px"} justifyContent={"center"}>
              <P>{shippingInfo && shippingInfo.phone}</P>
            </FlexChild>
          )}

          {!isMobile ? (
            <FlexChild width={"150px"} justifyContent={"flex-end"}>
              <button
                onClick={onModifyClick}
                style={{
                  border: "none",
                  backgroundColor: "white",
                  padding: "5px 10px",
                  border: "1px solid #e5e5e5",
                  borderRadius: "3px",
                  marginRight: "5px",
                }}
              >
                <p style={{ fontSize: "14px", color: "black" }}>
                  <FontAwesomeIcon icon={fas["faPenToSquare"]} />
                </p>
              </button>
              <button
                onClick={() => onDeleteClick(index)}
                style={{
                  border: "none",
                  backgroundColor: "white",
                  padding: "5px 10px",
                  border: "1px solid #296AFF",
                  borderRadius: "3px",
                  backgroundColor: "#296AFF",
                }}
              >
                <p style={{ fontSize: "14px", color: "white" }}>
                  <FontAwesomeIcon icon={fas["faTrashCan"]} />
                </p>
              </button>
            </FlexChild>
          ) : (
            <FlexChild width={"120px"}>
              <VerticalFlex gap={5}>
                <FlexChild alignItems={"flex-end"}>
                  <P
                    onClick={onModifyClick}
                    cursor
                    borderRadius={"3px"}
                    size={"10pt"}
                    border={"1px solid #999"}
                    padding={"2px 20px"}
                  >
                    수정
                  </P>
                </FlexChild>
                <FlexChild alignItems={"flex-end"}>
                  <P
                    onClick={() => onDeleteClick(index)}
                    color={"white"}
                    backgroundColor={"var(--main-color)"}
                    cursor
                    borderRadius={"3px"}
                    size={"10pt"}
                    border={"1px solid transperent"}
                    padding={"2px 20px"}
                  >
                    삭제
                  </P>
                </FlexChild>
              </VerticalFlex>
            </FlexChild>
          )}
        </HorizontalFlex>
      </FlexChild>
    </VerticalFlex>
  );
});

export default ShippingInfoRow;
